<div class="section">
  <div class="row">
    <div class="col-sm">
      <div class="close-header" style="margin-right: -35px; height: 10px">
        <img
          src="assets/images/icons/close-icon.png"
          style="margin: 10px 10px"
          (click)="oncancelClick()"
        />
        <!-- <mat-icon class="close-icon" (click)="oncancelClick()"> close</mat-icon> -->
      </div>
    </div>
  </div>

  <div class="tab-container" style="height: 1.9em !important">
    <mat-tab-group
      class="custom-tab-group"
      [ngClass]="{
        'tab-radius-recent': selectedIndex === 0,
        'tab-radius-search': selectedIndex === 1,
        'tab-radius-create': selectedIndex === 2,
        
      }"
      [(selectedIndex)]="selectedIndex"
      (selectedIndexChange)="onTabChanged($event)"
    >
      <mat-tab label="Recently Used" style="border-radius: 7px"></mat-tab>
      <mat-tab label="Search" style="border-radius: 7px"></mat-tab>
      <mat-tab
        label="Create"
        style="border-radius: 7px"
        class="createTab"
      ></mat-tab>
    </mat-tab-group>
  </div>
  <!-- Search Tab Content start -->
  <!-- style="height: 5vh; -->
  <div class="tab-content" *ngIf="selectedIndex === 1">
    <div class="row" style="height: 1.6em; width: 75em !important">
      <!-- style="height: 5vh" -->
      <div class="col-sm metadata-header" style="height: 1.9em">
        <div class="legend-icon"></div>
        <span class="metadata-title">Search For Substantiations</span>
        <div class="search-section">
          <div class="main-text">
            <input
              type="text"
              [(ngModel)]="searchText"
              (keydown.enter)="onSearchClick()"
              class="mdc-tab__text-label"
              placeholder="Type here to search"
              style="
                width: 100%;
                height: 100%;
                border: none;
                background: transparent;
                outline: none;
                font-size: inherit;
              "
            />
          </div>
          <div class="legendblack-icon"></div>
          <div class="mat-selection">
            <mat-radio-group [(ngModel)]="selectedSearchType">
              <mat-radio-button value="Product">Product</mat-radio-button>
              <mat-radio-button value="Project">Project</mat-radio-button>
              <mat-radio-button value="Claim/LA">Claim/LA</mat-radio-button>
              <mat-radio-button value="Document Name"
                >Document Name</mat-radio-button
              >
              <mat-radio-button value="Document Content"
                >Document Content</mat-radio-button
              >
            </mat-radio-group>

            <span
              style="
                display: inline-block;
                border-left: 1.5px solid #ced6e0;
                height: 18px;
                margin-left: 12px;
                margin-right: -9px;
                vertical-align: middle;
              "
            ></span>
            <mat-checkbox
              [(ngModel)]="createdByMeChecked"
              matTooltip="{{ createdbyMetooltipText }}"
              >Created By Me</mat-checkbox
            >
          </div>
          <div class="search-btn">
            <img
              src="assets/images/icons/search.png"
              style="margin: 10px 10px; cursor: pointer"
              (click)="onSearchClick()"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Main Table -->
    <div class="row" style="gap: 0 !important">
      <div class="col-sm table-container" style="min-height: 12.5em !important">
        <table mat-table [dataSource]="dataSource">
          <!-- Checkbox Column -->
          <ng-container matColumnDef="checkbox">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <mat-checkbox
                (change)="onToggleRow(element, $event)"
                [checked]="isSelected(element)"
              >
              </mat-checkbox>
            </td>
          </ng-container>
          <!-- Substantiation Id Column -->
          <ng-container matColumnDef="substantiationId">
            <th
              mat-header-cell
              *matHeaderCellDef
              style="padding: 0 !important"
              appClickOutside
              [ignoreOverlay]="true"
              (clickOutside)="substantiationIdSearch = false"
            >
              <div
                class="table-header"
                style="justify-content: normal !important"
              >
                <span
                  [ngClass]="{
                    'header-text-highlight': substantiationIdFilter.value
                  }"
                  >Substantiation Id</span
                >
                <img
                  src="assets/images/icons/search.svg"
                  (click)="toggleSubstantiationIdSearch()"
                  style="margin-left: 10px; cursor: pointer; margin-top: 3px"
                />
              </div>

              <div
                *ngIf="substantiationIdSearch"
                class="flex justify-between items-center input-container"
              >
                <div
                  class="flex search-container"
                  style="width: 9% !important; padding: 3px !important"
                >
                  <img
                    src="assets/images/icons/search.svg"
                    style="cursor: pointer"
                  />
                  <input
                    #searchInput
                    type="text"
                    class="search-input"
                    placeholder="Search here..."
                    [formControl]="substantiationIdFilter"
                    style="width: 7% !important; padding-left: 5px !important"
                  />
                  <img
                    *ngIf="substantiationIdFilter.value"
                    (click)="clearSearch()"
                    src="assets/images/icons/close-icon.png"
                    style="
                      cursor: pointer;
                      height: 10px !important;
                      width: 10px !important;
                    "
                  />
                </div>
              </div>
            </th>
            <!-- <td
              mat-cell
              *matCellDef="let element"
              style="
                text-decoration: underline;
                padding-left: 10px;
                cursor: pointer;
              "
            >
              {{ element.substantiationId }}
            </td> -->
            <td
              mat-cell
              *matCellDef="let element"
              style="
                text-decoration: underline;
                padding-left: 10px;
                cursor: pointer;
              "
            >
              <ng-container *ngIf="element.substantiation_link; else plainId">
                <a
                  [href]="element.substantiation_link"
                  target="_blank"
                  rel="noopener noreferrer"
                  style="color: #1f36c7"
                >
                  <!-- {{ element.substantiationId }} -->
                  <span
                    [innerHTML]="
                      element.substantiationId | highlight : searchText
                    "
                  ></span>
                </a>
              </ng-container>
              <ng-template #plainId>
                <!-- {{ element.substantiationId }} -->
                <span
                  [innerHTML]="
                    element.substantiationId | highlight : searchText
                  "
                ></span>
              </ng-template>
            </td>
          </ng-container>
          <!-- Description Column -->
          <ng-container matColumnDef="description">
            <th
              mat-header-cell
              *matHeaderCellDef
              style="z-index: 0 !important"
              appClickOutside
              [ignoreOverlay]="true"
              (clickOutside)="descriptionSearch = false"
            >
              <div
                class="table-header"
                style="justify-content: normal !important"
              >
                <span
                  [ngClass]="{
                    'header-text-highlight': descriptionFilter.value
                  }"
                  >Description</span
                >
                <img
                  src="assets/images/icons/search.svg"
                  (click)="toggleDescriptionSearch()"
                  style="
                    cursor: pointer;
                    margin-left: 25px !important;
                    margin-top: 3px;
                  "
                />
              </div>
              <div
                *ngIf="descriptionSearch"
                class="flex justify-between items-center input-container"
              >
                <div
                  class="flex search-container"
                  style="width: 12% !important; padding: 3px !important"
                >
                  <img
                    src="assets/images/icons/search.svg"
                    style="cursor: pointer"
                  />
                  <input
                    #searchInput
                    type="text"
                    class="search-input"
                    placeholder="Search here..."
                    [formControl]="descriptionFilter"
                    style="padding-left: 5px !important"
                  />
                  <img
                    (click)="descclearSearch()"
                    *ngIf="descriptionFilter.value"
                    src="assets/images/icons/close-icon.png"
                    style="
                      cursor: pointer;
                      height: 10px !important;
                      width: 10px !important;
                    "
                  />
                </div>
              </div>
            </th>
            <td mat-cell *matCellDef="let element" style="padding-left: 10px">
              <div
                class="ellipsis-1line"
                [matTooltip]="element.description"
                matTooltipClass="custom-tooltip"
              >
                <!-- {{ element.description }} -->
                <span
                  [innerHTML]="element.description | highlight : searchText"
                ></span>
              </div>
            </td>
          </ng-container>
          <!--related colmn-->
          <!-- Related Products Column -->
          <ng-container matColumnDef="relatedProducts">
            <th
              mat-header-cell
              *matHeaderCellDef
              appClickOutside
              [ignoreOverlay]="true"
              (clickOutside)="showRelatedProductsFilter = false"
            >
              <div class="table-header">
                <span
                  [ngClass]="{
                    'header-text-highlight': relatedProductsFilterCtrl.value
                  }"
                  >Related Products</span
                >
                <img
                  src="assets/images/icons/search.svg"
                  (click)="toggleRelatedProductsFilter()"
                  style="cursor: pointer; margin-top: 3px"
                />
              </div>

              <div
                *ngIf="showRelatedProductsFilter"
                class="flex justify-between items-center input-container"
              >
                <div
                  class="flex search-container"
                  style="width: 12% !important; padding: 5px !important"
                >
                  <img
                    src="assets/images/icons/search.svg"
                    style="cursor: pointer"
                  />
                  <input
                    #searchInput
                    type="text"
                    class="search-input"
                    placeholder="Search here..."
                    [formControl]="relatedProductsFilterCtrl"
                    style="width: 7% !important; padding-left: 5px !important"
                  />
                  <img
                    *ngIf="relatedProductsFilterCtrl.value"
                    (click)="clearProductSearch()"
                    src="assets/images/icons/close-icon.png"
                    style="
                      cursor: pointer;
                      height: 10px !important;
                      width: 10px !important;
                    "
                  />
                </div>
              </div>
            </th>

            <td mat-cell *matCellDef="let element">
              <ng-container *ngIf="getRelatedProducts(element)?.length">
                <div class="related-list">
                  <ng-container
                    *ngIf="
                      getLastLinesWithTwentyChars(
                        getRelatedProducts(element)
                      ) as result
                    "
                  >
                    <ng-container *ngFor="let line of result.lines">
                      <div>
                        <span
                          [innerHTML]="line | highlight : searchText"
                        ></span>
                      </div>
                    </ng-container>
                    <!-- Always show See More -->
                    <div>
                      <a
                        href="#"
                        (click)="openSeeMorePopup(element, 'products', $event)"
                        class="see-more-link"
                        >See More</a
                      >
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </td>
          </ng-container>

          <!-- Related Projects Column -->
          <ng-container matColumnDef="relatedProjects">
            <th
              mat-header-cell
              *matHeaderCellDef
              appClickOutside
              [ignoreOverlay]="true"
              (clickOutside)="showRelatedProjectsFilter = false"
            >
              <div class="table-header">
                <span
                  [ngClass]="{
                    'header-text-highlight': relatedProjectsFilterCtrl.value
                  }"
                  >Related Projects</span
                >
                <img
                  src="assets/images/icons/search.svg"
                  (click)="toggleRelatedProjectsFilter()"
                  style="cursor: pointer; margin-top: 3px"
                />
              </div>

              <div
                *ngIf="showRelatedProjectsFilter"
                class="flex justify-between items-center input-container"
              >
                <div
                  class="flex search-container"
                  style="width: 12% !important; padding: 5px !important"
                >
                  <img
                    src="assets/images/icons/search.svg"
                    style="cursor: pointer"
                  />
                  <input
                    #searchInput
                    type="text"
                    class="search-input"
                    placeholder="Search here..."
                    [formControl]="relatedProjectsFilterCtrl"
                    style="width: 7% !important; padding-left: 5px !important"
                  />
                  <img
                    *ngIf="relatedProjectsFilterCtrl.value"
                    (click)="clearProjectSearch()"
                    src="assets/images/icons/close-icon.png"
                    style="
                      cursor: pointer;
                      height: 10px !important;
                      width: 10px !important;
                    "
                  />
                </div>
              </div>
            </th>

            <td mat-cell *matCellDef="let element">
              <ng-container
                *ngIf="
                  getRelatedProjects(element) &&
                  getRelatedProjects(element).length > 0
                "
              >
                <div class="related-list">
                  <ng-container
                    *ngIf="
                      getRelatedProjectsSummary(
                        getRelatedProjects(element)
                      ) as res
                    "
                  >
                    <div>
                      <span
                        [innerHTML]="res.summary | highlight : searchText"
                      ></span>
                    </div>
                    <!-- Always show See More -->
                    <div>
                      <a
                        href="#"
                        (click)="openSeeMorePopup(element, 'projects', $event)"
                        class="see-more-link"
                        >See More</a
                      >
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </td>
          </ng-container>

          <!-- Related Claims/LA Column -->

          <ng-container matColumnDef="relatedClaims">
            <th
              mat-header-cell
              *matHeaderCellDef
              appClickOutside
              [ignoreOverlay]="true"
              (clickOutside)="showRelatedClaims = false"
            >
              <div class="table-header">
                <span
                  [ngClass]="{
                    'header-text-highlight': relatedClaimsFilterCtrl.value
                  }"
                  >Related Claims/LA</span
                >
                <img
                  src="assets/images/icons/search.svg"
                  (click)="toggleRelatedClaimsFilter()"
                  style="cursor: pointer; margin-top: 3px"
                />
              </div>

              <div
                *ngIf="showRelatedClaims"
                class="flex justify-between items-center input-container"
              >
                <div
                  class="flex search-container"
                  style="width: 17% !important; padding: 5px !important"
                >
                  <img
                    src="assets/images/icons/search.svg"
                    style="cursor: pointer"
                  />
                  <input
                    #searchInput
                    type="text"
                    class="search-input"
                    placeholder="Search here..."
                    [formControl]="relatedClaimsFilterCtrl"
                    style="width: 17% !important; padding-left: 5px !important"
                  />
                  <img
                    *ngIf="relatedClaimsFilterCtrl.value"
                    (click)="clearRelatedClaimsSearch()"
                    src="assets/images/icons/close-icon.png"
                    style="
                      cursor: pointer;
                      height: 10px !important;
                      width: 10px !important;
                    "
                  />
                </div>
              </div>
            </th>

            <td mat-cell *matCellDef="let element">
              <ng-container
                *ngIf="element.relatedClaims?.length; else noClaims"
              >
                <ng-container
                  *ngIf="getRelatedClaimsSummary(element.relatedClaims) as res"
                >
                  <div *ngFor="let line of res.lines">
                    <span [innerHTML]="line | highlight : searchText"></span>
                  </div>
                  <!-- Always show See More -->
                  <div>
                    <a
                      href="#"
                      (click)="openSeeMorePopup(element, 'claims', $event)"
                      class="see-more-link"
                      >See More</a
                    >
                  </div>
                </ng-container>
              </ng-container>
              <ng-template #noClaims>
                <span>-</span>
              </ng-template>
            </td>
          </ng-container>

          <!-- Document Link Column -->
          <ng-container matColumnDef="documentLink">
            <th mat-header-cell *matHeaderCellDef>Document Link</th>
            <td mat-cell *matCellDef="let element" style="padding-left: 10px">
              <!-- <a href="#" class="document-link">{{ element.documentLink }}</a> -->
              <a
                href="{{ element.documentLink }}"
                class="document-link"
                target="_blank"
                rel="noopener noreferrer"
                [matTooltip]="element.documentName"
                matTooltipClass="custom-tooltip"
              >
                <!-- {{ element.documentName }} -->
                <span
                  [innerHTML]="element.documentName | highlight : searchText"
                ></span>
              </a>
            </td>
          </ng-container>

          <!-- empty column-->
          <ng-container matColumnDef="documentUpload">
            <th mat-header-cell *matHeaderCellDef style="width: 10%"></th>
            <td mat-cell *matCellDef="let element">
              <!-- <ng-container
                *ngIf="
                  selectedSearchType === 'Document Name' ||
                  selectedSearchType === 'Document Content'
                "
              > -->
              <ng-container
                *ngIf="
                  (lastSearchType === 'Document Name' ||
                    lastSearchType === 'Document Content') &&
                  element.documentLink
                "
              >
                <a (click)="onDocumentImageClick(element)">
                  <img
                    src="assets/images/icons/file-document-outline.png"
                    alt="Document"
                    style="width: 16px; height: 16px; cursor: pointer"
                  />
                </a>
              </ng-container>
            </td>
          </ng-container>
          <!-- Table Header and Rows -->
          <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
            class="table-header-class"
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; let i = index; columns: displayedColumns"
            [ngClass]="{
              tableRow: true,
              'odd-row': i % 2 !== 0,
              'even-row': i % 2 === 0
            }"
          ></tr>
        </table>

        <div
          *ngIf="noDataMessage && dataSource.data.length === 0"
          class="no-records-message"
        >
          {{ noDataMessage }}
        </div>
      </div>
      <mat-paginator
        *ngIf="dataSource?.data?.length > 10"
        [length]="dataSource?.data?.length || 0"
        [pageSize]="10"
        [pageSizeOptions]="[10]"
        [hidePageSize]="true"
        showFirstLastButtons
        aria-label="Select page"
        style="color: #49526e"
      >
      </mat-paginator>
    </div>

    <!-- Selected Table (shows below main table if any row is selected) -->
    <div class="row">
      <div
        class="col-sm selectedtable"
        style="margin: 0px 0px 10px 25px !important"
      >
        <div class="row">
          <div
            class="col-sm metadata-header"
            style="padding-left: 10px !important; padding-top: 9px !important"
          >
            <div class="legend-icon-selected"></div>
            <span class="metadata-title-selected"
              >Selected Substantiations</span
            >
          </div>
        </div>
        <div
          *ngIf="selectedSubstantiations.length > 0"
          class="table-container search-selected-table"
        >
          <table
            mat-table
            [dataSource]="selectedSubstantiations"
            style="box-shadow: none"
          >
            <!-- Checkbox Column (checked and allows unselect) -->
            <ng-container matColumnDef="checkbox">
              <td mat-cell *matCellDef="let element">
                <mat-checkbox
                  [checked]="true"
                  (change)="removeFromSelected(element)"
                >
                </mat-checkbox>
              </td>
            </ng-container>
            <!-- Substantiation Id -->
            <!-- <ng-container matColumnDef="substantiationId">
              <td
                mat-cell
                *matCellDef="let element"
                style="text-decoration: underline; cursor: pointer"
              >
                {{ element.substantiationId }}
              </td>
            </ng-container> -->
            <ng-container matColumnDef="substantiationId">
              <td
                mat-cell
                *matCellDef="let element"
                class="selected-substantiationId"
              >
                <ng-container *ngIf="element.substantiation_link; else plainId">
                  <a
                    [href]="element.substantiation_link"
                    target="_blank"
                    rel="noopener noreferrer"
                    style="
                      color: inherit;
                      text-decoration: underline;
                      color: #1f36c7;
                    "
                  >
                    {{ element.substantiationId }}
                  </a>
                </ng-container>
                <ng-template #plainId>
                  {{ element.substantiationId }}
                </ng-template>
              </td>
            </ng-container>
            <!-- Description -->
            <ng-container matColumnDef="description">
              <td
                mat-cell
                *matCellDef="let element"
                style="padding-left: 0px"
                class="selected-description"
              >
                {{ element.description }}
              </td>
            </ng-container>

            <!-- Related Products OR Geography Fallback Column -->
            <ng-container matColumnDef="relatedProducts">
              <td
                mat-cell
                *matCellDef="let element"
                class="selected-relatedProducts"
              >
                <!-- Show Related Products if present -->
                <ng-container
                  *ngIf="
                    getRelatedProducts(element)?.length > 0;
                    else showSubstantiationDetails
                  "
                >
                  <div class="related-list">
                    <ng-container
                      *ngIf="
                        getLastLinesWithTwentyChars(
                          getRelatedProducts(element)
                        ) as result
                      "
                    >
                      <ng-container *ngFor="let line of result.lines">
                        <div>
                          <span
                            [innerHTML]="line | highlight : searchText"
                          ></span>
                        </div>
                      </ng-container>
                      <div>
                        <a
                          href="#"
                          (click)="
                            openSeeMorePopup(element, 'products', $event)
                          "
                          class="see-more-link"
                        >
                          See More
                        </a>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>

                <!-- Show substantiationDetails if no related products -->
                <ng-template #showSubstantiationDetails>
                  <ng-container *ngIf="element.substantiationDetails">
                    <div
                      [matTooltip]="element.substantiationDetails"
                      matTooltipClass="custom-tooltip"
                      style="
                        min-width: 160px !important;
                        max-width: 170px !important;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                      "
                    >
                      {{ element.substantiationDetails }}
                    </div>
                  </ng-container>
                </ng-template>
              </td>
            </ng-container>

            <!-- Related Projects OR Substantiation Details Fallback Column -->
            <ng-container matColumnDef="relatedProjects">
              <td
                mat-cell
                *matCellDef="let element"
                class="search-selected-relatedProjects"
              >
                <!-- Show Related Projects if present, otherwise show Substantiation Details if present, else empty -->

                <ng-container
                  *ngIf="
                    getRelatedProjects(element) &&
                      getRelatedProjects(element).length > 0;
                    else showGeography
                  "
                >
                  <div class="related-list">
                    <ng-container
                      *ngIf="
                        getRelatedProjectsSummary(
                          getRelatedProjects(element)
                        ) as res
                      "
                    >
                      <div>
                        <span
                          [innerHTML]="res.summary | highlight : searchText"
                        ></span>
                      </div>
                      <!-- Always show See More -->
                      <div>
                        <a
                          href="#"
                          (click)="
                            openSeeMorePopup(element, 'projects', $event)
                          "
                          class="see-more-link"
                          >See More</a
                        >
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
                <ng-template #showGeography>
                  <span>{{ element.geography }}</span>
                </ng-template>

                <!-- <ng-template #showsubType>
                  <ng-container
                    *ngIf="element.subtype; else showEmpty2"
                    [matTooltip]="element.subtype"
                    matTooltipClass="custom-tooltip"
                  >
                    {{ element.subtype }}
                  </ng-container>
                  <ng-template #showEmpty2>
                    <span></span>
                  </ng-template>
                </ng-template> -->
              </td>
            </ng-container>

            <!-- Related Claims/LA Column -->

            <ng-container matColumnDef="relatedClaims">
              <td
                mat-cell
                *matCellDef="let element"
                class="search-selected-relatedClaims"
              >
                <ng-container
                  *ngIf="element.relatedClaims?.length; else showsubType"
                >
                  <ng-container
                    *ngIf="
                      getRelatedClaimsSummary(element.relatedClaims) as res
                    "
                  >
                    <div *ngFor="let line of res.lines">
                      <span [innerHTML]="line | highlight : searchText"></span>
                    </div>
                    <div>
                      <a
                        href="#"
                        (click)="openSeeMorePopup(element, 'claims', $event)"
                        class="see-more-link"
                      >
                        See More
                      </a>
                    </div>
                  </ng-container>
                </ng-container>
                <ng-template #showsubType>
                  <ng-container
                    *ngIf="element.subType; else showEmpty2"
                    [matTooltip]="element.subType"
                    matTooltipClass="custom-tooltip"
                  >
                    {{ element.subType }}
                  </ng-container>
                  <ng-template #showEmpty2>
                    <span></span>
                  </ng-template>
                </ng-template>
                <!-- <ng-template #showGeography>
                  <span class="geo">{{ element.geography }}</span>
                </ng-template> -->

                <!-- <ng-template #showGeography>
                  <ng-container *ngIf="element.geography; else showSubtype">
                    <span>{{ element.geography }}</span>
                  </ng-container>
                </ng-template>

                <ng-template #showSubtype>
                  <span>{{ element.subType }}</span>
                </ng-template> -->
              </td>
            </ng-container>
            <!-- Document Link -->
            <ng-container matColumnDef="documentLink">
              <td
                mat-cell
                *matCellDef="let element"
                style="padding-left: 0px !important"
              >
                <a
                  href="{{ element.documentLink }}"
                  class="document-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  [matTooltip]="element.documentName"
                  matTooltipClass="custom-tooltip"
                >
                  <span
                    [innerHTML]="element.documentName | highlight : searchText"
                  ></span>
                </a>
              </td>
            </ng-container>
            <!-- Document upload Column -->
            <ng-container matColumnDef="documentUpload">
              <td
                mat-cell
                *matCellDef="let element"
                style="padding: 0 !important"
              >
                <ng-container
                  *ngIf="
                    selectedSearchType === 'Document Name' ||
                    selectedSearchType === 'Document Content'
                  "
                >
                  <a (click)="onDocumentImageClick(element)">
                    <img
                      src="assets/images/icons/file-document-outline.png"
                      alt="Document"
                      style="width: 16px; height: 16px; cursor: pointer"
                    />
                  </a>
                </ng-container>
              </td>
            </ng-container>
            <!-- Remove Button Column -->
            <ng-container matColumnDef="remove">
              <td
                mat-cell
                *matCellDef="let element"
                style="
                  text-align: end;
                  width: 3% !important;
                  padding-right: 0px;
                  padding-left: 0px;
                "
              >
                <!-- <button
                  mat-icon-button
                  class="no-hover-bg"
                  (click)="removeFromSelected(element)"
                  [disableRipple]="true"
                > -->
                <img
                  (click)="removeFromSelected(element)"
                  src="assets/images/icons/Close_Icon.png"
                  alt="Remove"
                  class="remove-icon"
                  style="
                    height: 14px !important;
                    width: 14px !important;
                    cursor: pointer;
                  "
                />
                <!-- </button> -->
              </td>
            </ng-container>

            <!-- Table Row -->
            <tr
              mat-row
              *matRowDef="
                let row;
                let i = index;
                columns: [
                  'checkbox',
                  'substantiationId',
                  'description',
                  'relatedProducts',
                  'relatedProjects',
                  'relatedClaims',
                  'documentLink',
                  'documentUpload',
                  'remove'
                ]
              "
              [ngClass]="{
                tableRow: true,
                'odd-row': i % 2 !== 0,
                'even-row': i % 2 === 0
              }"
            ></tr>
          </table>
        </div>
        <div *ngIf="selectedSubstantiations.length === 0" class="no-records">
          <span> No substantiations have been selected</span>
        </div>
      </div>
    </div>

    <div class="row button-section">
      <div class="col-sm" style="padding: 0">
        <div class="button-class" style="margin-top: 0px !important">
          <button
            mat-stroked-button
            class="btn-text-cancel"
            (click)="oncancelClick()"
          >
            Cancel
          </button>
          &nbsp;
          <button
            mat-stroked-button
            class="btn-text-proceed"
            (click)="confirmSelection()"
            [disabled]="isConfirmDisabled"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Search Tab Content End -->

  <!-- Create Tab Content Start -->
  <div
    class="tab-content"
    style="padding: 0px !important"
    *ngIf="selectedIndex === 2"
  >
    <div class="container" style="padding: 5px 20px 20px 20px">
      <div class="row">
        <div class="col-sm" class="metadata-header">
          <div class="legend-icon"></div>
          <span class="metadata-title">Create Substantiations</span>
        </div>
      </div>

      <!-- Substantiation Data-->
      <form [formGroup]="createDataForm">
        <div class="selects-row">
          <div class="doc-upload-field">
            <label class="doc-upload-label"
              >Document
              <span class="label-icon">*</span>
            </label>
            <div class="doc-upload-input-wrapper">
              <input
                class="doc-upload-input"
                type="text"
                placeholder="Upload here"
                formControlName="documentName"
                (input)="onNameInput($event)"
                style="font-size: 12px; font-family: Unilever Shilling"
              />

              <span class="doc-upload-divider"></span>
              <label class="doc-upload-icon">
                <input
                  type="file"
                  style="display: none"
                  (change)="onFileSelected($event)"
                />
                <img src="assets/images/icons/file-upload.svg" alt="Upload" />
              </label>
            </div>
            <div
              class="doc-upload-file-name"
              [class.filled]="createDataForm.get('documentName')?.value"
            >
              <span style="font-size: 12px">
                <!-- {{
                  createDataForm.get("documentName")?.value.trim() || "No File Chosen"?.trim()
                }} -->
                {{
                  (
                    createDataForm.get("documentName")?.value ||
                    "No File Chosen"
                  )?.trim()
                }}
                <span
                  *ngIf="documentExtension"
                  style="color: #49526e; margin-left: -3px"
                  >{{ documentExtension }}</span
                >
              </span>
            </div>
          </div>
          <div class="select-col">
            <label class="select-label"
              >Substantiation Evidence Subtype
              <span class="label-icon">*</span>
            </label>
            <mat-form-field appearance="outline" class="select-mat-field">
              <mat-select
                formControlName="evidenceSubtype"
                disableOptionCentering
              >
                <mat-option
                  *ngFor="let opt of subtype_options"
                  [value]="opt.value"
                >
                  {{ opt.label }}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="
                  createDataForm.get('evidenceSubtype').hasError('required') &&
                  createDataForm.get('evidenceSubtype').touched
                "
              >
                Substantiation Evidence Subtype is required
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="selects-row" style="margin: 2px 110px !important">
          <div class="select-col">
            <label class="select-label"
              >Description
              <span class="label-icon">*</span>
            </label>
            <!-- <label class="select-label">Description</label> -->

            <!-- style="height: 15vh !important" -->
            <mat-form-field
              class="custom-textarea-field textarea-field"
              appearance="outline"
              style="height: 4.8em !important"
            >
              <!-- [formControl]="descriptionControl" -->
              <textarea
                matInput
                placeholder="Type here"
                maxlength="1500"
                formControlName="description"
                [(ngModel)]="desc"
                style="
                  font-size: 12px !important;
                  font-family: Unilever Shilling;
                  color: #49526e;
                  min-height: 65px !important;
                  height: 50px;
                  max-height: 100px;
                  padding: 0px 0 0 6px !important;
                  line-height: 14px;
                "
              ></textarea>
              <mat-error
                *ngIf="
                  createDataForm.get('description').hasError('required') &&
                  createDataForm.get('description').touched
                "
              >
                Description is required
              </mat-error>
              <div class="count-div">
                <div class="count-text">{{ desc?.length || 0 }}/1500</div>
              </div>
            </mat-form-field>
          </div>
          <div class="select-col">
            <label class="select-label">Substantiation Details</label>
            <!-- style="height: 15vh !important" -->
            <mat-form-field
              class="custom-textarea-field textarea-field"
              appearance="outline"
              style="height: 4.8em !important"
            >
              <textarea
                matInput
                placeholder="Type here"
                maxlength="32000"
                formControlName="supportSummaryText"
                [(ngModel)]="subDetails"
                style="
                  font-size: 12px !important;
                  font-family: Unilever Shilling;
                  color: #49526e;
                  min-height: 65px !important;
                  height: 50px;
                  max-height: 100px;
                  padding: 0px 0 0 6px !important;
                  line-height: 14px;
                "
              >
              </textarea>
              <div class="count-div" align="end">
                <div class="count-text" align="end">
                  {{ subDetails.length }}/32000
                </div>
              </div>
            </mat-form-field>
          </div>
        </div>

        <div
          class="selects-row"
          style="margin: 2px 110px 20px 110px !important"
        >
          <div class="select-col">
            <label class="select-label">Geography</label>
            <mat-form-field appearance="outline" class="select-mat-field">
              <mat-select formControlName="geography" disableOptionCentering>
                <mat-option
                  *ngFor="let geography of filteredCountryOptions"
                  [value]="geography.value"
                >
                  {{ geography.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <!-- <div class="select-col">
            <label class="select-label">Geography</label>
            <p-dropdown
              [options]="filteredCountryOptions"
              [(ngModel)]="selectedGeography"
              optionLabel="label"
              [ngModelOptions]="{ standalone: true }"
              placeholder="Type or select geography"
              [filter]="true"
              filterBy="label"
              class="select-mat-field"
              [showClear]="true"
              class="custom-dropdown"
              [ngClass]="{
                'placeholder-opacity': selectedGeography
              }"
            ></p-dropdown>
          </div> -->

          <div class="select-col">
            <div class="row button-section">
              <div class="col-sm">
                <div
                  class="button-class"
                  style="
                    justify-content: left !important;
                    margin-top: 28px !important;
                  "
                >
                  <!-- As it is not in scope currently-->
                  <!-- <button
                    mat-stroked-button
                    class="btn-text-cancel"
                    (click)="oncancelClick()"
                    style="margin-left: 0px !important"
                  >
                    Create & Add to Cart
                  </button>
                  &nbsp; -->
                  <!-- <button mat-stroked-button class="btn-text-proceed">
                    Create
                  </button>  -->
                  <!-- <button
                    mat-stroked-button
                    class="btn-text-proceed"
                    type="button"
                    (click)="onCreateSubstantiation()"
                  >
                    Create
                  </button> -->
                  <button
                    mat-stroked-button
                    class="btn-text-proceed"
                    type="button"
                    (click)="onCreateSubstantiation()"
                    [disabled]="isCreateDisabled"
                  >
                    Create
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>

      <!-- Selected Table for create Tab -->

      <div class="row" style="margin-top: -20px">
        <div class="col-sm selectedtable">
          <div class="row">
            <div
              class="col-sm metadata-header"
              style="padding-left: 10px !important; padding-top: 7px !important"
            >
              <div class="legend-icon-selected"></div>
              <span class="metadata-title-selected"
                >Selected Substantiations</span
              >
            </div>
          </div>
          <!-- This is for both tabs -->
          <!-- min-height: 16vh;
              max-height: 16vh; -->
          <div
            *ngIf="selectedSubstantiations.length > 0"
            class="table-container"
            style="
              margin-left: 0px;
              margin-bottom: 0px !important;
              margin-top: 5px !important;
              width: 100% !important;
              min-height: 6.3em !important;
              max-height: 6.3em !important;
            "
          >
            <table
              mat-table
              [dataSource]="selectedSubstantiations"
              style="box-shadow: none"
            >
              <!-- Checkbox Column (checked and allows unselect) -->
              <ng-container matColumnDef="checkbox">
                <td mat-cell *matCellDef="let element">
                  <mat-checkbox
                    [checked]="true"
                    (change)="removeFromSelected(element)"
                  >
                  </mat-checkbox>
                </td>
              </ng-container>
              <!-- Substantiation Id -->
              <!-- <ng-container matColumnDef="substantiationId">
                <td
                  mat-cell
                  *matCellDef="let element"
                  style="text-decoration: underline; cursor: pointer"
                >
                  {{ element.substantiationId }}
                </td>
              </ng-container> -->
              <ng-container matColumnDef="substantiationId">
                <td
                  mat-cell
                  *matCellDef="let element"
                  style="text-decoration: underline; cursor: pointer"
                >
                  <ng-container
                    *ngIf="element.substantiation_link; else plainId"
                  >
                    <a
                      [href]="element.substantiation_link"
                      target="_blank"
                      rel="noopener noreferrer"
                      style="
                        color: inherit;
                        text-decoration: underline;
                        color: #1f36c7;
                      "
                    >
                      {{ element.substantiationId }}
                    </a>
                  </ng-container>
                  <ng-template #plainId>
                    {{ element.substantiationId }}
                  </ng-template>
                </td>
              </ng-container>
              <!-- Description -->
              <ng-container matColumnDef="description">
                <td
                  mat-cell
                  *matCellDef="let element"
                  style="padding-left: 0px; min-width: 180px !important"
                  [matTooltip]="element.description"
                  matTooltipClass="custom-tooltip"
                >
                  {{ element.description }}
                </td>
              </ng-container>

              <!-- Related Products OR substantiationDetails Column -->
              <ng-container matColumnDef="relatedProducts">
                <td mat-cell *matCellDef="let element">
                  <!-- Show Related Products if present -->
                  <ng-container
                    *ngIf="
                      getRelatedProducts(element)?.length > 0;
                      else showSubstantiationDetails
                    "
                  >
                    <div class="related-list">
                      <ng-container
                        *ngIf="
                          getLastLinesWithTwentyChars(
                            getRelatedProducts(element)
                          ) as result
                        "
                      >
                        <ng-container *ngFor="let line of result.lines">
                          <div>
                            <span [innerHTML]="line"></span>
                          </div>
                        </ng-container>
                        <div>
                          <a
                            href="#"
                            (click)="
                              openSeeMorePopup(element, 'products', $event)
                            "
                            class="see-more-link"
                          >
                            See More
                          </a>
                        </div>
                      </ng-container>
                    </div>
                  </ng-container>

                  <!-- Show substantiationDetails if no related products -->
                  <ng-template #showSubstantiationDetails>
                    <ng-container *ngIf="element.substantiationDetails">
                      <div
                        [matTooltip]="element.substantiationDetails"
                        matTooltipClass="custom-tooltip"
                        style="
                          min-width: 160px !important;
                          max-width: 170px !important;
                          white-space: nowrap;
                          overflow: hidden;
                          text-overflow: ellipsis;
                        "
                      >
                        {{ element.substantiationDetails }}
                      </div>
                    </ng-container>
                  </ng-template>
                </td>
              </ng-container>

              <!-- Related Projects OR Substantiation Details Fallback Column -->
              <ng-container matColumnDef="relatedProjects">
                <td
                  mat-cell
                  *matCellDef="let element"
                  style="
                    min-width: 145px !important;
                    max-width: 145px !important;
                  "
                >
                  <!-- Show Related Projects if present, otherwise show Substantiation Details if present, else empty -->

                  <ng-container
                    *ngIf="
                      getRelatedProjects(element) &&
                        getRelatedProjects(element).length > 0;
                      else showGeography
                    "
                  >
                    <div class="related-list">
                      <ng-container
                        *ngIf="
                          getRelatedProjectsSummary(
                            getRelatedProjects(element)
                          ) as res
                        "
                      >
                        <div>
                          <span [innerHTML]="res.summary"></span>
                        </div>
                        <!-- Always show See More -->
                        <div>
                          <a
                            href="#"
                            (click)="
                              openSeeMorePopup(element, 'projects', $event)
                            "
                            class="see-more-link"
                            >See More</a
                          >
                        </div>
                      </ng-container>
                    </div>
                  </ng-container>

                  <ng-template #showGeography>
                    <span>{{ element.geography }}</span>
                  </ng-template>
                </td>
              </ng-container>

              <!-- Related Claims/LA Column -->
              <ng-container matColumnDef="relatedClaims">
                <td mat-cell *matCellDef="let element">
                  <ng-container
                    *ngIf="element.relatedClaims?.length; else showsubType"
                  >
                    <ng-container
                      *ngIf="
                        getRelatedClaimsSummary(element.relatedClaims) as res
                      "
                    >
                      <div *ngFor="let line of res.lines">
                        <span [innerHTML]="line"></span>
                      </div>
                      <div>
                        <a
                          href="#"
                          (click)="openSeeMorePopup(element, 'claims', $event)"
                          class="see-more-link"
                        >
                          See More
                        </a>
                      </div>
                    </ng-container>
                  </ng-container>

                  <ng-template #showsubType>
                    <ng-container
                      *ngIf="element.subType; else showEmpty2"
                      [matTooltip]="element.subType"
                      matTooltipClass="custom-tooltip"
                    >
                      <span class="subtype">{{ element.subType }}</span>
                    </ng-container>
                    <ng-template #showEmpty2>
                      <span>-</span>
                    </ng-template>
                  </ng-template>
                  <!-- <ng-template #showGeography>
                    <span>{{ element.geography }}</span>
                  </ng-template> -->
                </td>
              </ng-container>

              <!-- Document Link -->
              <ng-container matColumnDef="documentLink">
                <td mat-cell *matCellDef="let element">
                  <a
                    href="{{ element.documentLink }}"
                    class="document-link"
                    target="_blank"
                    rel="noopener noreferrer"
                    [matTooltip]="element.documentName"
                    matTooltipClass="custom-tooltip"
                  >
                    <span
                      [innerHTML]="
                        element.documentName | highlight : searchText
                      "
                    ></span>
                  </a>
                </td>
              </ng-container>
              <!-- Document upload Column -->
              <ng-container matColumnDef="documentUpload">
                <td
                  mat-cell
                  *matCellDef="let element"
                  style="padding: 0 !important"
                >
                  <ng-container
                    *ngIf="
                      selectedSearchType === 'Document Name' ||
                      selectedSearchType === 'Document Content'
                    "
                  >
                    <a (click)="onDocumentImageClick(element)">
                      <img
                        src="assets/images/icons/file-document-outline.png"
                        alt="Document"
                        style="width: 16px; height: 16px; cursor: pointer"
                      />
                    </a>
                  </ng-container>
                </td>
              </ng-container>
              <!-- Remove Button Column -->

              <ng-container matColumnDef="remove">
                <td
                  mat-cell
                  *matCellDef="let element"
                  style="
                    text-align: end;
                    width: 3% !important;
                    padding: 0 !important;
                  "
                >
                  <!-- <button
                    mat-icon-button
                    class="no-hover-bg"
                    (click)="removeFromSelected(element)"
                    [disableRipple]="true"
                  > -->
                  <img
                    (click)="removeFromSelected(element)"
                    src="assets/images/icons/Close_Icon.png"
                    alt="Remove"
                    class="remove-icon"
                    style="
                      height: 14px !important;
                      width: 14px !important;
                      cursor: pointer;
                    "
                  />
                  <!-- </button> -->
                </td>
              </ng-container>

              <!-- Table Row -->
              <tr
                mat-row
                *matRowDef="
                  let row;
                  let i = index;
                  columns: [
                    'checkbox',
                    'substantiationId',
                    'description',
                    'relatedProducts',
                    'relatedProjects',
                    'relatedClaims',
                    'documentLink',
                    'documentUpload',
                    'remove'
                  ]
                "
                [ngClass]="{
                  tableRow: true,
                  'odd-row': i % 2 !== 0,
                  'even-row': i % 2 === 0
                }"
              ></tr>
            </table>
          </div>
          <div *ngIf="selectedSubstantiations.length === 0" class="no-records">
            <span> No substantiations have been selected</span>
          </div>
        </div>
      </div>

      <div class="row button-section">
        <div class="col-sm" style="padding: 0">
          <div class="button-class" style="margin-top: 0px !important">
            <button
              mat-stroked-button
              class="btn-text-cancel"
              (click)="oncancelClick()"
            >
              Cancel
            </button>
            &nbsp;
            <button
              mat-stroked-button
              class="btn-text-proceed"
              (click)="confirmSelection()"
              [disabled]="isConfirmDisabled"
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Create Tab Content End -->

  <!-- Recently used Tab Start -->
  <div
    class="tab-content"
    style="padding: 0px !important"
    *ngIf="selectedIndex === 0"
  >
    <!-- Main Table -->
    <div class="row" style="gap: 0 !important">
      <div class="col-sm table-container" style="min-height: 14.8em !important">
        <table mat-table [dataSource]="recent_dataSource">
          <!-- Checkbox Column -->
          <ng-container matColumnDef="recent_checkbox">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <mat-checkbox
                (change)="onToggleRow(element, $event)"
                [checked]="isSelected(element)"
                style="padding-right: 5px"
              >
              </mat-checkbox>
            </td>
          </ng-container>
          <!-- Substantiation Id Column -->
          <ng-container matColumnDef="recent_substantiationId">
            <th
              mat-header-cell
              *matHeaderCellDef
              style="padding: 6px !important"
              appClickOutside
              [ignoreOverlay]="true"
              (clickOutside)="recentsubstantiationIdSearch = false"
            >
              <div
                class="table-header"
                style="justify-content: normal !important"
              >
                <span
                  [ngClass]="{
                    'header-text-highlight': recentsubstantiationIdFilter.value
                  }"
                  >Substantiation Id</span
                >
                <img
                  src="assets/images/icons/search.svg"
                  (click)="toggleRecentSubstantiationIdSearch()"
                  style="margin-left: 10px; cursor: pointer; margin-top: 3px"
                />
              </div>

              <div
                *ngIf="recentsubstantiationIdSearch"
                class="flex justify-between items-center input-container"
              >
                <div
                  class="flex search-container"
                  style="width: 9% !important; padding: 3px !important"
                >
                  <img
                    src="assets/images/icons/search.svg"
                    style="cursor: pointer"
                  />
                  <input
                    #searchInput
                    type="text"
                    class="search-input"
                    placeholder="Search here..."
                    [formControl]="recentsubstantiationIdFilter"
                    style="width: 7% !important; padding-left: 5px !important"
                  />
                  <img
                    *ngIf="recentsubstantiationIdFilter.value"
                    (click)="recentclearSearch()"
                    src="assets/images/icons/close-icon.png"
                    style="
                      cursor: pointer;
                      height: 10px !important;
                      width: 10px !important;
                    "
                  />
                </div>
              </div>
            </th>

            <td
              mat-cell
              *matCellDef="let element"
              style="
                text-decoration: underline;
                padding-left: 10px;
                cursor: pointer;
              "
            >
              <ng-container *ngIf="element.substantiation_link; else plainId">
                <a
                  [href]="element.substantiation_link"
                  target="_blank"
                  rel="noopener noreferrer"
                  style="color: #1f36c7"
                >
                  <!-- {{ element.substantiationId }} -->
                  <span [innerHTML]="element.substantiationId"></span>
                </a>
              </ng-container>
              <ng-template #plainId>
                <!-- {{ element.substantiationId }} -->
                <span [innerHTML]="element.substantiationId"></span>
              </ng-template>
            </td>
          </ng-container>
          <!-- Description Column -->
          <ng-container matColumnDef="recent_description">
            <th
              mat-header-cell
              *matHeaderCellDef
              style="z-index: 0 !important"
              appClickOutside
              [ignoreOverlay]="true"
              (clickOutside)="recentdescriptionSearch = false"
            >
              <div class="table-header">
                <span
                  [ngClass]="{
                    'header-text-highlight': recentdescriptionFilter.value
                  }"
                  >Description</span
                >
                <img
                  src="assets/images/icons/search.svg"
                  (click)="toggleRecentDescriptionSearch()"
                  style="cursor: pointer; margin-top: 3px"
                />
              </div>
              <div
                *ngIf="recentdescriptionSearch"
                class="flex justify-between items-center input-container"
              >
                <div class="flex search-container recent-search-description">
                  <img
                    src="assets/images/icons/search.svg"
                    style="cursor: pointer"
                  />
                  <input
                    #searchInput
                    type="text"
                    class="search-input"
                    placeholder="Search here..."
                    [formControl]="recentdescriptionFilter"
                    class="recent-search-input"
                  />
                  <img
                    (click)="recentdescclearSearch()"
                    *ngIf="recentdescriptionFilter.value"
                    src="assets/images/icons/close-icon.png"
                    style="
                      cursor: pointer;
                      height: 10px !important;
                      width: 10px !important;
                    "
                  />
                </div>
              </div>
            </th>
            <td mat-cell *matCellDef="let element" style="padding-left: 10px">
              <div
                class="ellipsis-1line"
                [matTooltip]="element.description"
                matTooltipClass="custom-tooltip"
              >
                <!-- {{ element.description }} -->
                <span [innerHTML]="element.description"></span>
              </div>
            </td>
          </ng-container>
          <!--related colmn-->
          <!-- Related Products Column -->
          <ng-container matColumnDef="recent_relatedProducts">
            <th
              mat-header-cell
              *matHeaderCellDef
              appClickOutside
              [ignoreOverlay]="true"
              (clickOutside)="recentshowRelatedProductsFilter = false"
            >
              <div class="table-header">
                <span
                  [ngClass]="{
                    'header-text-highlight':
                      recentrelatedProductsFilterCtrl.value
                  }"
                  >Related Products</span
                >
                <img
                  src="assets/images/icons/search.svg"
                  (click)="toggleRecentRelatedProductsFilter()"
                  style="cursor: pointer; margin-top: 3px"
                />
              </div>

              <div
                *ngIf="recentshowRelatedProductsFilter"
                class="flex justify-between items-center input-container"
              >
                <div
                  class="flex search-container"
                  style="width: 12% !important; padding: 5px !important"
                >
                  <img
                    src="assets/images/icons/search.svg"
                    style="cursor: pointer"
                  />
                  <input
                    #searchInput
                    type="text"
                    class="search-input"
                    placeholder="Search here..."
                    [formControl]="recentrelatedProductsFilterCtrl"
                    style="width: 7% !important; padding-left: 5px !important"
                  />
                  <img
                    *ngIf="recentrelatedProductsFilterCtrl.value"
                    (click)="recentclearProductSearch()"
                    src="assets/images/icons/close-icon.png"
                    style="
                      cursor: pointer;
                      height: 10px !important;
                      width: 10px !important;
                    "
                  />
                </div>
              </div>
            </th>

            <td mat-cell *matCellDef="let element">
              <ng-container *ngIf="getRelatedProducts(element)?.length">
                <div class="related-list">
                  <ng-container
                    *ngIf="
                      getLastLinesWithTwentyChars(
                        getRelatedProducts(element)
                      ) as result
                    "
                  >
                    <ng-container *ngFor="let line of result.lines">
                      <div>
                        <span [innerHTML]="line"></span>
                      </div>
                    </ng-container>
                    <!-- Always show See More -->
                    <div>
                      <a
                        href="#"
                        (click)="openSeeMorePopup(element, 'products', $event)"
                        class="see-more-link"
                        >See More</a
                      >
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </td>
          </ng-container>

          <!-- Related Projects Column -->
          <ng-container matColumnDef="recent_relatedProjects">
            <th
              mat-header-cell
              *matHeaderCellDef
              appClickOutside
              [ignoreOverlay]="true"
              (clickOutside)="recentshowRelatedProjectsFilter = false"
            >
              <div class="table-header">
                <span
                  [ngClass]="{
                    'header-text-highlight':
                      recentrelatedProjectsFilterCtrl.value
                  }"
                  >Related Projects</span
                >
                <img
                  src="assets/images/icons/search.svg"
                  (click)="toggleRecentRelatedProjectsFilter()"
                  style="cursor: pointer; margin-top: 3px"
                />
              </div>

              <div
                *ngIf="recentshowRelatedProjectsFilter"
                class="flex justify-between items-center input-container"
              >
                <div
                  class="flex search-container"
                  style="width: 12% !important; padding: 5px !important"
                >
                  <img
                    src="assets/images/icons/search.svg"
                    style="cursor: pointer"
                  />
                  <input
                    #searchInput
                    type="text"
                    class="search-input"
                    placeholder="Search here..."
                    [formControl]="recentrelatedProjectsFilterCtrl"
                    style="width: 7% !important; padding-left: 5px !important"
                  />
                  <img
                    *ngIf="recentrelatedProjectsFilterCtrl.value"
                    (click)="recentclearProjectSearch()"
                    src="assets/images/icons/close-icon.png"
                    style="
                      cursor: pointer;
                      height: 10px !important;
                      width: 10px !important;
                    "
                  />
                </div>
              </div>
            </th>

            <td mat-cell *matCellDef="let element">
              <ng-container
                *ngIf="
                  getRelatedProjects(element) &&
                  getRelatedProjects(element).length > 0
                "
              >
                <div class="related-list">
                  <ng-container
                    *ngIf="
                      getRelatedProjectsSummary(
                        getRelatedProjects(element)
                      ) as res
                    "
                  >
                    <div>
                      <span [innerHTML]="res.summary"></span>
                    </div>
                    <!-- Always show See More -->
                    <div>
                      <a
                        href="#"
                        (click)="openSeeMorePopup(element, 'projects', $event)"
                        class="see-more-link"
                        >See More</a
                      >
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </td>
          </ng-container>

          <ng-container matColumnDef="recent_subType">
            <th
              mat-header-cell
              *matHeaderCellDef
              appClickOutside
              [ignoreOverlay]="true"
              (clickOutside)="recentSubType = false"
            >
              <div class="table-header">
                <span
                  [ngClass]="{
                    'header-text-highlight': recentsubTypeFilterCtrl.value
                  }"
                  >SubType</span
                >
                <img
                  src="assets/images/icons/search.svg"
                  (click)="toggleRecentSubType()"
                  style="cursor: pointer; margin-top: 3px"
                />
              </div>

              <div
                *ngIf="recentSubType"
                class="flex justify-between items-center input-container"
              >
                <div
                  class="flex search-container"
                  style="width: 12% !important; padding: 5px !important"
                >
                  <img
                    src="assets/images/icons/search.svg"
                    style="cursor: pointer"
                  />
                  <input
                    #searchInput
                    type="text"
                    class="search-input"
                    placeholder="Search here..."
                    [formControl]="recentsubTypeFilterCtrl"
                    style="width: 17% !important; padding-left: 5px !important"
                  />
                  <img
                    *ngIf="recentsubTypeFilterCtrl.value"
                    (click)="clearRecentSubTypeSearch()"
                    src="assets/images/icons/close-icon.png"
                    style="
                      cursor: pointer;
                      height: 10px !important;
                      width: 10px !important;
                    "
                  />
                </div>
              </div>
            </th>

            <td mat-cell *matCellDef="let element">
              <ng-container>
                <div>
                  {{ element.subType }}
                </div>
              </ng-container>
            </td>
          </ng-container>

          <!-- Document Link Column -->
          <ng-container matColumnDef="recent_documentLink">
            <th mat-header-cell *matHeaderCellDef>Document Link</th>
            <td mat-cell *matCellDef="let element" style="padding-left: 10px">
              <!-- <a href="#" class="document-link">{{ element.documentLink }}</a> -->
              <a
                href="{{ element.documentLink }}"
                class="document-link"
                target="_blank"
                rel="noopener noreferrer"
                [matTooltip]="element.documentName"
                matTooltipClass="custom-tooltip"
              >
                <!-- {{ element.documentName }} -->
                <span [innerHTML]="element.documentName"></span>
              </a>
            </td>
          </ng-container>

          <!-- Table Header and Rows -->
          <tr
            mat-header-row
            *matHeaderRowDef="recentlyUseddisplayedColumns; sticky: true"
            class="table-header-class"
            style="height: 50px !important"
          ></tr>
          <tr
            mat-row
            *matRowDef="
              let row;
              let i = index;
              columns: recentlyUseddisplayedColumns
            "
            [ngClass]="{
              tableRow: true,
              'odd-row': i % 2 !== 0,
              'even-row': i % 2 === 0
            }"
          ></tr>
        </table>

        <div
          *ngIf="noDataMessagerecentlyUsed && dataSource.data.length === 0"
          class="no-records-message"
        >
          {{ noDataMessagerecentlyUsed }}
        </div>
      </div>
      <mat-paginator
        *ngIf="recent_dataSource?.data?.length > 5"
        [length]="recent_dataSource?.data?.length || 0"
        [pageSize]="5"
        [pageSizeOptions]="[5]"
        [hidePageSize]="true"
        showFirstLastButtons
        aria-label="Select page"
        style="color: #49526e"
      >
      </mat-paginator>
    </div>

    <!-- Selected Table For Recently used Tab-->
    <div class="row">
      <div
        class="col-sm selectedtable"
        style="margin: 12px 0px 10px 25px !important"
      >
        <div class="row">
          <div
            class="col-sm metadata-header"
            style="padding-left: 10px !important; padding-top: 11px !important"
          >
            <div class="legend-icon-selected"></div>
            <span class="metadata-title-selected"
              >Selected Substantiations</span
            >
          </div>
        </div>
        <!-- This is for both tabs -->
        <div
          *ngIf="selectedSubstantiations.length > 0"
          class="table-container"
          style="
            margin-left: 0px;
            margin-bottom: 0px !important;
            margin-top: 5px !important;
            width: 100% !important;
            min-height: 20vh;
            max-height: 20vh;
          "
        >
          <table
            mat-table
            [dataSource]="selectedSubstantiations"
            style="box-shadow: none"
          >
            <!-- Checkbox Column (checked and allows unselect) -->
            <ng-container matColumnDef="checkbox">
              <td
                mat-cell
                *matCellDef="let element"
                class="recent-selected-checkbox"
              >
                <mat-checkbox
                  [checked]="true"
                  (change)="removeFromSelected(element)"
                >
                </mat-checkbox>
              </td>
            </ng-container>
            <!-- Substantiation Id -->
            <ng-container matColumnDef="substantiationId">
              <td
                mat-cell
                *matCellDef="let element"
                class="recent-selected-substantiationId"
              >
                <ng-container *ngIf="element.substantiation_link; else plainId">
                  <a
                    [href]="element.substantiation_link"
                    target="_blank"
                    rel="noopener noreferrer"
                    style="
                      color: inherit;
                      text-decoration: underline;
                      color: #1f36c7;
                    "
                  >
                    {{ element.substantiationId }}
                  </a>
                </ng-container>
                <ng-template #plainId>
                  {{ element.substantiationId }}
                </ng-template>
              </td>
            </ng-container>
            <!-- Description -->
            <ng-container matColumnDef="description">
              <td
                mat-cell
                *matCellDef="let element"
                class="recent-selected-description"
                [matTooltip]="element.description"
                matTooltipClass="custom-tooltip"
              >
                {{ element.description }}
              </td>
            </ng-container>

            <!-- Related Products OR substantiationDetails Column -->

            <ng-container matColumnDef="relatedProducts">
              <td
                mat-cell
                *matCellDef="let element"
                class="recent-selected-relatedProducts"
              >
                <!-- Show Related Products if present -->
                <ng-container
                  *ngIf="
                    getRelatedProducts(element)?.length > 0;
                    else showSubstantiationDetails
                  "
                >
                  <div class="related-list">
                    <ng-container
                      *ngIf="
                        getLastLinesWithTwentyChars(
                          getRelatedProducts(element)
                        ) as result
                      "
                    >
                      <ng-container *ngFor="let line of result.lines">
                        <div>
                          <span [innerHTML]="line"></span>
                        </div>
                      </ng-container>
                      <div>
                        <a
                          href="#"
                          (click)="
                            openSeeMorePopup(element, 'products', $event)
                          "
                          class="see-more-link"
                        >
                          See More
                        </a>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>

                <!-- Show substantiationDetails if no related products -->
                <ng-template #showSubstantiationDetails>
                  <ng-container *ngIf="element.substantiationDetails">
                    <div
                      [matTooltip]="element.substantiationDetails"
                      matTooltipClass="custom-tooltip"
                      style="
                        min-width: 160px !important;
                        max-width: 170px !important;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                      "
                    >
                      {{ element.substantiationDetails }}
                    </div>
                  </ng-container>
                </ng-template>
              </td>
            </ng-container>

            <!-- Related Projects OR Substantiation Details Fallback Column -->
            <ng-container matColumnDef="relatedProjects">
              <td
                mat-cell
                *matCellDef="let element"
                class="recent-selected-relatedProjects"
              >
                <!-- Show Related Projects if present, otherwise show Substantiation Details if present, else empty -->

                <ng-container
                  *ngIf="
                    getRelatedProjects(element) &&
                      getRelatedProjects(element).length > 0;
                    else checkGeography
                  "
                >
                  <div class="related-list">
                    <ng-container
                      *ngIf="
                        getRelatedProjectsSummary(
                          getRelatedProjects(element)
                        ) as res
                      "
                    >
                      <div>
                        <span [innerHTML]="res.summary"></span>
                      </div>
                      <!-- Always show See More -->
                      <div>
                        <a
                          href="#"
                          (click)="
                            openSeeMorePopup(element, 'projects', $event)
                          "
                          class="see-more-link"
                          >See More</a
                        >
                      </div>
                    </ng-container>
                  </div>
                </ng-container>

                <ng-template #checkGeography>
                  <ng-container>
                    <span>{{ element.geography }}</span>
                  </ng-container>
                </ng-template>

                <!-- <ng-template #showsubType>
                  <ng-container
                    *ngIf="element.subtype; else showEmpty2"
                    [matTooltip]="element.subtype"
                    matTooltipClass="custom-tooltip"
                  >
                    {{ element.subtype }}
                  </ng-container>
                  <ng-template #showEmpty2>
                    <span></span>
                  </ng-template>
                </ng-template> -->
              </td>
            </ng-container>

            <!-- Related Claims/LA Column  OR geography OR subType -->

            <ng-container matColumnDef="relatedClaims">
              <td
                mat-cell
                *matCellDef="let element"
                class="recent-selected-relatedClaims"
              >
                <ng-container
                  *ngIf="element.relatedClaims?.length > 0; else showSubtype"
                >
                  <ng-container
                    *ngIf="
                      getRelatedClaimsSummary(element.relatedClaims) as res
                    "
                  >
                    <div *ngFor="let line of res.lines">
                      <span
                        class="recent-related-text"
                        [innerHTML]="line"
                      ></span>
                    </div>
                    <div>
                      <a
                        href="#"
                        (click)="openSeeMorePopup(element, 'claims', $event)"
                        class="see-more-link"
                      >
                        See More
                      </a>
                    </div>
                  </ng-container>
                </ng-container>

                <ng-template #showSubtype>
                  <span>{{ element.subType }}</span>
                </ng-template>

                <!-- <ng-template #checkGeography>
                  <ng-container *ngIf="element.geography; else showSubtype">
                    <span>{{ element.geography }}</span>
                  </ng-container>
                </ng-template>

                <ng-template #showSubtype>
                  <span>{{ element.subType }}</span>
                </ng-template> -->
              </td>
            </ng-container>

            <!-- Document Link -->
            <ng-container matColumnDef="documentLink">
              <td mat-cell *matCellDef="let element">
                <a
                  href="{{ element.documentLink }}"
                  class="document-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  [matTooltip]="element.documentName"
                  matTooltipClass="custom-tooltip"
                >
                  <span [innerHTML]="element.documentName"></span>
                </a>
              </td>
            </ng-container>
            <!-- Document upload Column -->
            <ng-container matColumnDef="documentUpload">
              <td
                mat-cell
                *matCellDef="let element"
                style="padding: 0 !important"
              >
                <ng-container
                  *ngIf="
                    selectedSearchType === 'Document Name' ||
                    selectedSearchType === 'Document Content'
                  "
                >
                  <a (click)="onDocumentImageClick(element)">
                    <img
                      src="assets/images/icons/file-document-outline.png"
                      alt="Document"
                      style="width: 16px; height: 16px; cursor: pointer"
                    />
                  </a>
                </ng-container>
              </td>
            </ng-container>
            <!-- Remove Button Column -->

            <ng-container matColumnDef="remove">
              <td
                mat-cell
                *matCellDef="let element"
                style="
                  text-align: end;
                  width: 3% !important;
                  padding: 0 !important;
                "
              >
                <!-- <button
                  mat-icon-button
                  class="no-hover-bg"
                  (click)="removeFromSelected(element)"
                  [disableRipple]="true"
                > -->
                <img
                  (click)="removeFromSelected(element)"
                  src="assets/images/icons/Close_Icon.png"
                  alt="Remove"
                  class="remove-icon"
                  style="
                    height: 14px !important;
                    width: 14px !important;
                    cursor: pointer;
                  "
                />
                <!-- </button> -->
              </td>
            </ng-container>

            <!-- Table Row -->
            <tr
              mat-row
              *matRowDef="
                let row;
                let i = index;
                columns: [
                  'checkbox',
                  'substantiationId',
                  'description',
                  'relatedProducts',
                  'relatedProjects',
                  'relatedClaims',
                  'documentLink',
                  'documentUpload',
                  'remove'
                ]
              "
              [ngClass]="{
                tableRow: true,
                'odd-row': i % 2 !== 0,
                'even-row': i % 2 === 0
              }"
            ></tr>
          </table>
        </div>
        <div *ngIf="selectedSubstantiations.length === 0" class="no-records">
          <span> No substantiations have been selected</span>
        </div>
      </div>
    </div>

    <div class="row button-section">
      <div class="col-sm" style="padding: 0">
        <div class="button-class" style="margin-top: 0px !important">
          <button
            mat-stroked-button
            class="btn-text-cancel"
            (click)="oncancelClick()"
          >
            Cancel
          </button>
          &nbsp;
          <button
            mat-stroked-button
            class="btn-text-proceed"
            (click)="confirmSelection()"
            [disabled]="isConfirmDisabled"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Recently used Tab End-->
</div>
